import { Component,OnInit } from '@angular/core';
import {InviteFriendPage} from '../invitefriend/invitefriend';
import { NavController  } from 'ionic-angular';
//import { Contacts} from 'ionic-native';
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import { AlertController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { LoadingController } from 'ionic-angular';


@Component({
	selector: 'page-referfriends',
	templateUrl: 'referfriends.html',
	providers: [MydataService,MyUrlService,JsonData,Contacts]
})
export class ReferFriendsPage implements OnInit{
	allContacts:Array<any>;
	jsonDt : Array<JsonData>;
	//displayContact:any;
	//allContacts:Array<any>;
	//vdsvfd:Array<any>;
	displayContact:any;
	cont:string;
	constructor(public navCtrl: NavController,private contacts: Contacts,public alerCtrl: AlertController,public loading: LoadingController,private http:Http,private mydataService: MydataService,private myurlService: MyUrlService) {
	}
	
	
	ngOnInit()
	{
		let loader = this.loading.create({content: '',});
		loader.present().then(() => {
			this.contacts.find(['*']).then((contacts)=>{
				this.contactDetails(loader,contacts);
				
			})
		});	
		
	}
	contactDetails=function(loader,contacts){
		//this.allContac=window.localStorage.getItem('contactt');
		//alert("all Cont===>"+this.allContac);
		this.allContacts=contacts;
		window.localStorage.setItem("allContacts",this.allContacts);
		loader.dismiss();
	}
	
	invitefriend()
	{
		var userid=window.localStorage.getItem('userid');
		var value=null;
		for(var i=0;i<this.allContacts.length;i++){
			this.displayContact=this.allContacts[i]._objectInstance;
			//alert("pre this.displayContact===>"+this.displayContact+"  "+window.localStorage.getItem(this.displayContact.phoneNumbers[0].value));
			
			if(window.localStorage.getItem(this.displayContact.displayName)!=null){
				//alert("pre time===>"+window.localStorage.getItem(this.displayContact.displayName)+"    "+i);
				if(value!=null){
					var adadad = {"userid":userid,"name":window.localStorage.getItem(this.displayContact.displayName),"mobileno":window.localStorage.getItem(this.displayContact.phoneNumbers[0].value)};
					value=value+","+JSON.stringify(adadad);
					
					//		alert("second time===>"+value)
					this.cont=window.localStorage.getItem(this.displayContact.displayName)+this.cont;
					window.localStorage.removeItem(this.displayContact.displayName);
					
					////console.log("second time===>"+value);
					}else{
					//window.localStorage.setItem("namee",this.displayContact.displayName);
					value =	{"userid":userid,"name":window.localStorage.getItem(this.displayContact.displayName),"mobileno":this.displayContact.phoneNumbers[0].value};
					value = JSON.stringify(value);
					this.cont=window.localStorage.getItem(this.displayContact.displayName);
					window.localStorage.removeItem(this.displayContact.displayName);
					//		    alert("first time===>"+value)
					////console.log("first time===>"+value)
				}
			}
		}
		
		if(value!=null){
			//alert("hello found inside your_string" + this.cont);
			if(this.mydataService.checkInternetFunction()=="0"){
				////console.log("Internet UnAvailable")
				}else  if(this.mydataService.checkInternetFunction()=="1"){
				
				value = "["+value+"]";
				window.localStorage.setItem("sentReferal",value);
				//alert("final select  contacts===>"+value);
				let loader = this.loading.create({content: '',});
				var referFriendData = JSON.stringify({"invitefriends":JSON.parse(value)});
				//alert("call web "+referFriendData);
				loader.present().then(() => {
					this.mydataService.postJSON(this.myurlService.REFERRALCODE ,referFriendData).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.callReferCode(loader));
				});	
			}
			}else{
			this.errorAlert();
		}
	}
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
	}
	callReferCode = function(loader){	
		loader.dismiss();
		//alert("referal Code respose===>"+JSON.stringify(this.jsonDt));
		this.datas = this.jsonDt.datas;
		if(this.datas=="Saved Successfully"){
			this.showAlert();
		}
		
	}
	contactCheckBox(contName,contMobileNo)
	{
		for(var i=0;i<this.allContacts.length;i++)
		{
			this.displayContact=this.allContacts[i]._objectInstance;
			if(this.displayContact.displayName==contName){
				//window.localStorage.setItem(this.displayContact.displayName,null);
				if(window.localStorage.getItem(this.displayContact.displayName)!=null){
					//alert("remove data ===> "+window.localStorage.getItem(contName)+"    "+contMobileNo);
					window.localStorage.removeItem(contName);
					window.localStorage.removeItem(contMobileNo);
					break;
					}else{
					//alert("setvalue in local");
					window.localStorage.setItem(contName,contName);
					window.localStorage.setItem(contMobileNo,contMobileNo);
					//alert(" store===>"+window.localStorage.getItem(contName)+"    "+window.localStorage.getItem(contMobileNo));
					break;
					
				}
				
			}
		}
		
	}
	showAlert=function() {
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: "Your Invitation Sent successfully",
			buttons: [ {
				text: 'Ok',
				handler: data => {
					this.navCtrl.push(InviteFriendPage);			
				}
			}
			]
		});
		alert.present();
	}
	errorAlert=function() {
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: "Please Select Contact",
			buttons: [ {
				text: 'Ok',
				handler: data => {
					//this.navCtrl.push(InviteFriendPage);			
				}
			}
			]
		});
		alert.present();
	}
	
	generateTopics()
     {
		 this.allContacts;
		 }
	getItems(ev: any)
	{
	  this.generateTopics();
		let serVal=ev.target.value;
		//  alert(serVal);
		if(serVal && serVal.trim()!='')
		{
			this.allContacts=this.allContacts.filter((a)=>{
				return(a.toLowerCase().indexOf(serVal.toLowerCase()) > -1)
			})
		}
		
		
	}
}



// WEBPACK FOOTER //
// ./src/pages/referfriends/referfriends.ts